import { MCD } from '@/services/app';
import AvatarOptions from './AvatarOptions';
import { useRef, useState, useEffect } from 'react';
import type { IAvatarOptionsPanelPops } from './types';
import AvatarOptionsButtons from '@/components/AvatarOptionsButtons';
import AvatarOptionsPanelContainer from './AvatartOptionsPanel.styles';

type AppVersion = {
  platform: string;
  version: string;
  build: string;
};

const AvatarOptionsPanel: React.FC<IAvatarOptionsPanelPops> = ({
  translations,
  disabledSave,
  disabledBack,
  onBackClick,
  onSaveClick,
  onNextClick,
  scrollRight,
  onTabClick,
  setOptions,
  activeTab,
  options
}) => {
  const [visibleButtons, setVisibleButtons] = useState(true);
  const [isFocus, setIsFocus] = useState<boolean>(false);

  const newVersion = useRef(false);

  const toggleButtons = (visible: boolean) => {
    setVisibleButtons(visible);
  };

  useEffect(() => {
    MCD.getAppVersion().then((data) => {
      const { version } = data as AppVersion;
      newVersion.current = version.startsWith('3.0');
    });
  }, []);

  return (
    <AvatarOptionsPanelContainer
      isFocus={isFocus && !newVersion.current}
      buttons={visibleButtons}
    >
      <AvatarOptions
        toggleButtons={toggleButtons}
        translations={translations}
        scrollRight={scrollRight}
        onTabClick={onTabClick}
        setOptions={setOptions}
        setIsFocus={setIsFocus}
        activeTab={activeTab}
        options={options}
      />

      {visibleButtons && (
        <AvatarOptionsButtons
          backLabel={translations.start_cta_back}
          nextLabel={translations.start_cta_next}
          disabledSave={disabledSave || !options.name}
          disabledNext={!options.name}
          disabledBack={disabledBack}
          onNextClick={onNextClick}
          onSaveClick={onSaveClick}
          onBackClick={onBackClick}
        />
      )}
    </AvatarOptionsPanelContainer>
  );
};

export default AvatarOptionsPanel;
